/* eslint-disable no-restricted-globals */
import { toJS } from 'mobx';
// @ts-nocheck
import React, { useEffect, useState, useRef } from 'react';
import { AmountBadge } from '../../components/AmountBadge';
import { CartBonuses } from '../../components/CartBonuses';
import Counter from '../../components/counter';
import { Oval } from 'react-loader-spinner';
import { useReactToPrint } from 'react-to-print';
import Seo from 'components/Seo';
import { PICS_URL } from '../../api';
import CartPackichQuote from '../../components/quote/cart_quote';
import { format_price } from '../../js/utils';
import { HtmlContent } from 'utils';
import empty from '../../assets/images/cart-empty.png';
import { useStores } from 'hooks/useStores';
import { TOKEN_KEYS } from 'const/settings';
import { getCookie } from 'utils/Cookie';
import { ROUTES_PATHS } from 'const';
import { observer } from 'mobx-react';

import '../../styles/cart.css';
import { Link } from 'react-router-dom';
import { EmptyIcon } from 'components/Cards/ProductCard/components/EmptyIcon';

const Cart = observer(() => {
  // проверяем залогинен ли пользователь
  const [isLogin, setIsLogin] = useState(false);
  const { api, cartStore, modalStore } = useStores();
  const {
    getCart,
    cartInfo,
    clearCart,
    cartItems,
    totalItems,
    removeCartItem,
    getCartItems,
    editCartItem,
    editCart,
  } = cartStore;

  useEffect(() => {
    if (getCookie(TOKEN_KEYS.AUTH_TOKEN_KEY) !== undefined) {
      setIsLogin(true);
    }
  }, []);

  // основное получение списка товаров для проверки не пустая ли корзина
  const [isLoaded, setIsLoaded] = useState(false);
  const [fetch, setFetch] = useState(1);
  const deliveryRadioRef = useRef(undefined);
  const selfRadioRef = useRef(undefined);

  useEffect(() => {
    setIsLoaded(false);
    getCartItems()
      .then(() => setIsLoaded(true))
      .catch((error) => {
        if (error.response.status === 500) {
          throw new Error();
        }
      });

    api.content.getCartTotalComponents().then((res) => setTotalText(res));
  }, [fetch]);
  // ____________________________

  // получение итогового окна
  const [isLoadedTotal, setIsLoadedTotal] = useState(false);
  const [totalText, setTotalText] = useState({});

  // ____________________________

  // изменение количества у товара
  const [putCount, setPutCount] = useState(1);
  const [itemQuantity, setItemQuantity] = useState(0);
  const [packQuantity, setPackQuantity] = useState(0);
  const [isLoadedPrice, setIsLoadedPrice] = useState(false);

  useEffect(() => {
    setIsLoadedPrice(false);
    setIsLoadedTotal(false);
    getCartItems().then(() => {
      setIsLoadedPrice(true);
    });
    getCart().then(() => setIsLoadedTotal(true));
  }, []);

  const didMount = useRef(false);
  let debounceHandler = null;
  //useDebounce
  useEffect(() => {
    //without didMount ref this would be execued when the component mounts, which we don't want
    if (didMount.current) {
      debounceHandler = setTimeout(() => {
        fetchItemsCount(itemQuantity);
      }, 400);
      //cleanUp function
      return () => {
        clearTimeout(debounceHandler);
      };
    } else {
      didMount.current = true;
    }
  }, [itemQuantity]);

  const didMountPack = useRef(false);
  //useDebounce
  useEffect(() => {
    //without didMount ref this would be execued when the component mounts, which we don't want
    if (didMountPack.current) {
      debounceHandler = setTimeout(() => {
        fetchPacksCount(packQuantity);
      }, 400);
      //cleanUp function
      return () => {
        clearTimeout(debounceHandler);
      };
    } else {
      didMountPack.current = true;
    }
  }, [packQuantity]);

  const fetchItemsCount = () => {
    let package_quantity = 0;
    const item = cartItems.find((el) => el.cart_item_id === putCount);
    package_quantity = itemQuantity / item?.product.in_pack_count;

    editCartItem(putCount, {
      item_quantity: itemQuantity,
      package_quantity: package_quantity,
    }).then(() => {getCart(); getCartItems();});
  };

  const fetchPacksCount = () => {
    let item_quantity = 0;
    const item = cartItems.find((el) => el.cart_item_id === putCount);
    item_quantity = packQuantity * item?.product.in_pack_count;

    editCartItem(putCount, {
      item_quantity: item_quantity,
      package_quantity: packQuantity,
    }).then(() => {getCart(); getCartItems();});
  };

  const countHandler = (id, count) => {
    const itemName = id.split('_')[1];
    const itemId = id.split('_')[0];
    if (itemName === 'item') {
      setItemQuantity(Number(count));
      setPutCount(Number(itemId));
    }
    if (itemName === 'pack') {
      setPackQuantity(Number(count));
      setPutCount(Number(itemId));
    }
  };

  const handleDeleteItem = (cartItemId) => {
    removeCartItem(cartItemId).then(() => {getCart(); getCartItems();});
  };

  // радио кнопка
  // useEffect(() => {
  //   if (isLoadedTotal) {
  //     if (cartItems.length !== 0) {
  //       if (cartInfo.delivery === true) {
  //           deliveryRadioRef.current.checked = true;
  //       } else {
  //           selfRadioRef.current.checked = true;
  //       }
  //     }
  //   }
  // }, [isLoadedTotal, cartInfo]);

  const radioHandlerSelf = () => {
    editCart(cartInfo.id, { delivery: false });
  };

  const radioHandlerDelivery = () => {
    editCart(cartInfo.id, { delivery: true });
  };
  // ____________________________

  // удалить все товары
  const clearAll = () => {
    clearCart().then(() => {
      setFetch(fetch + 1);
    });
  };

  const handleClickEnter = () => {
    modalStore.open('login');
  };

  // печать
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => location.reload(),
  });

  const [context, setContext] = useState({});
  useEffect(() => {
    api.content.getPageApi('cart').then((response) => {
      setContext(response.init_state.object);
    });
  }, []);

  return (
    <main>
      <section className="cart">
        <div className="cart-wrap">
          <Seo seo={context} />
          <div ref={componentRef}>
            {isLoaded ? (
              totalItems || cartItems?.length !== 0 ? (
                <div className="cart-nonEmpty">
                  <h1 className="cart-title">Корзина ({totalItems})</h1>
                  <div className="cart-content">
                    <div className="cart-content__goods">
                      <div className="goods-wrap">
                        <div className="goods-topLinks">
                          <button
                            className="topLinks-print"
                            onClick={handlePrint}
                          >
                            <div className="topLinks-print-icon"></div>
                            <div className="topLinks-print-title">
                              Распечатать
                            </div>
                          </button>
                          <button onClick={clearAll} className="topLinks-clear">
                            <div className="topLinks-clear-icon"></div>
                            <div className="topLinks-clear-title">Очистить</div>
                          </button>
                        </div>
                        <div className="goods-border"></div>
                        {context.tooltip ? (
                          <div className="goods-topTip">
                            <div className="topTip-icon"></div>
                            <div className="topTip-title">
                              <HtmlContent content={context.tooltip} />
                            </div>
                          </div>
                        ) : null}
                        <div className="goods-items">
                          {cartItems?.map((item, i) => (
                            <div
                              key={item.cart_item_id}
                              id={i}
                              className="goods-item"
                            >
                              <div className="item-wrap">
                                <div className="item-image">
                                  {item.product.image === null ? (
                                    <EmptyIcon minHeight="44px" />
                                  ) : (
                                    <img loading="lazy"
                                      src={item.product.image}
                                      alt={item.product.title}
                                    />
                                  )}
                                </div>
                                <div className="item-text">
                                  <p>{item.product.title}</p>
                                  {item.product.in_stock == 'в наличии' ||
                                  item.product.in_stock == 'В наличии' ? (
                                    <p className="cart-inStock">
                                      {item.product.in_stock}
                                    </p>
                                  ) : (
                                    <p className="cart-outStock">
                                      {item.product.in_stock}
                                    </p>
                                  )}
                                </div>
                                <div className="item-counters">
                                  {item.package_quantity === 0 ? null : (
                                    <div className="counter-item counter-item-packages">
                                      <div className="counter-item-title">
                                        {item.product.package_count_text !== ''
                                          ? item.product.package_count_text
                                          : 'Количество, уп:'}
                                      </div>
                                      <Counter
                                        id={`${item.cart_item_id}_pack`}
                                        minCount={item.product.min_pack_count}
                                        step={1}
                                        propsCount={item.package_quantity}
                                        multiplicity={item.product.multiplicity}
                                        packsCounter={true}
                                        restart={countHandler}
                                      />
                                    </div>
                                  )}
                                  <div className="counter-item">
                                    <div className="counter-item-title">
                                      <div className="gloves-setting-item__title">
                                        {item.product.count_text !== ''
                                          ? item.product.count_text
                                          : 'Количество, шт:'}
                                        {item.package_quantity !== 0 && (
                                          <span className="tooltip">
                                            <span className="tooltiptext">
                                              {item.product
                                                .package_count_hint !== ''
                                                ? item.product
                                                    .package_count_hint
                                                : `1 коробка = ${item.product.in_pack_count} штук(и)`}
                                            </span>
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                    <Counter
                                      id={`${item.cart_item_id}_item`}
                                      minCount={
                                        item.product.min_pack_count > 1
                                          ? item.product.min_pack_count *
                                            item.product.in_pack_count
                                          : item.product.multiplicity
                                      }
                                      step={item.product.multiplicity}
                                      propsCount={item.item_quantity}
                                      multiplicity={item.product.multiplicity}
                                      restart={countHandler}
                                    />
                                  </div>
                                </div>
                                <div className="item-price">
                                  <div className="item-price-total">
                                    {format_price(item.total_price)} ₽
                                  </div>
                                  <div className="item-prices">
                                    <div className="item-price-max">
                                      {format_price(item.old_price)} ₽/шт.
                                    </div>
                                    <div className="item-price-perOne">
                                      {format_price(item.new_price)} ₽/шт.
                                    </div>
                                  </div>
                                </div>
                                <button
                                  onClick={() =>
                                    handleDeleteItem(item.cart_item_id)
                                  }
                                  className="item-arrow"
                                />
                              </div>
                              {i + 1 != totalItems ? (
                                <div className="item-border" />
                              ) : null}
                            </div>
                          ))}
                          {!isLoadedPrice ? (
                            <div className="cart-loader-calc">
                              <Oval color="#ffd600" height={100} width={100} />
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div className="cart-content__total">
                      <div className="total-wrap">
                        <div className="total-main">
                          <div className="total-heading">
                            <h3>Итого</h3>
                            {isLoadedTotal && (
                              <h3>{format_price(cartInfo.total)} ₽</h3>
                            )}
                          </div>
                          <h4 className="total-heading-NDS">
                            Цены указаны с учетом НДС
                          </h4>
                          {isLoadedTotal && cartInfo.bonuses_count > 0 && (
                            <CartBonuses amount={cartInfo.bonuses_count} />
                          )}
                          <div className="total-border" />
                          <div className="total-shipping">
                            {isLoadedPrice && (
                              <form className="radio-settings">
                                <div className="form_radio">
                                  <input
                                    id="radio-1"
                                    ref={selfRadioRef}
                                    defaultChecked={!cartInfo?.delivery}
                                    type="radio"
                                    name="delivery"
                                    value="1"
                                    onClick={radioHandlerSelf}
                                  />
                                  <label htmlFor="radio-1">Самовывоз</label>
                                </div>
                                <div className="form_radio">
                                  <input
                                    id="radio-2"
                                    ref={deliveryRadioRef}
                                    defaultChecked={cartInfo?.delivery}
                                    type="radio"
                                    name="delivery"
                                    value="1"
                                    onClick={radioHandlerDelivery}
                                  />
                                  <label htmlFor="radio-2">Доставка</label>
                                </div>
                              </form>
                            )}
                          </div>
                          <a
                            className="total-button-addToCart"
                            href={ROUTES_PATHS.CART_REG}
                          >
                            <div className="button-addToCart-main">
                              <div className="total-button-title">
                                Перейти к оформлению
                              </div>
                            </div>
                          </a>
                          {!isLogin && (
                            <div
                              className="total-addText"
                              dangerouslySetInnerHTML={{
                                __html: totalText?.text_1,
                              }}
                            />
                          )}
                        </div>
                        {!isLogin && (
                          <div className="total-addText-buttons">
                            <Link
                              className="total-addText-buttons-reg"
                              to={ROUTES_PATHS.REGISTRATION}
                            >
                              Регистрация
                            </Link>
                            <button
                              className="total-addText-buttons-login"
                              onClick={handleClickEnter}
                            >
                              Вход
                            </button>
                          </div>
                        )}
                      </div>
                      {context.pak_pakych_quote ? (
                        <CartPackichQuote
                          text={context.pak_pakych_quote.text}
                          bgColor={context.pak_pakych_quote.bg_color}
                          borderColor={context.pak_pakych_quote.border_color}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="cart-empty">
                  <h1 className="cart-title">Корзина пуста</h1>
                  <h2 className="cart-subtitle">
                    Здесь отображаются товары, которые вы добавили в заказ
                  </h2>
                  <img loading="lazy" src={empty} className="cart-empty-img" alt=""></img>
                </div>
              )
            ) : (
              <div className="cart-loader">
                <Oval color="#ffd600" height={200} width={200} />
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
});

export default Cart;
